<template>
  <BaseModal
    :show="show"
    @close="close"
  >
    <header class="text-center pb-4">
      <h3
        class="my-0 font-bold"
        v-text="'Replace Document'"
      />
    </header>
    <div class="modal-body text-center">
      <div class="mb-6 text-center w-full">
        <BaseDropzone
          id="dropzone"
          ref="documentUpload"
          :options="dropzoneOptions"
          @dropzone-files-added="isUploading = true"
          @dropzone-error="uploadHasErrored"
          @dropzone-success="fileHasBeenUploaded"
          @dropzone-queue-complete="isUploading = false"
        />
      </div>
      <div class="flex justify-center items-baseline modal-footer text-center mt-4">
        <button
          type="button"
          class="btn"
          :disabled="!uploadingIsDone"
          :aria-disabled="!uploadingIsDone"
          @click.prevent="replace"
          v-text="'Replace'"
        />
        <a
          href="#"
          class="mx-4"
          @click.prevent="close"
          v-text="'Cancel'"
        />
      </div>
    </div>
  </BaseModal>
</template>

<script type="text/babel">
export default {
  name: 'ReplaceDocumentModal',
  data() {
    return {
      isUploading: false,
      targetFolder: null,
      uploadedFile: null,
      dropzoneOptions: {
        url: this.$urlGenerator.active('api/v1/documents/upload'),
      },
    }
  },
  computed: {
    uploadingIsDone() {
      return this.uploadedFile && !this.isUploading
    },
    previousDocument() {
      return this.$store.state.document.replaceDocumentModal.document
    },
    previousDocumentFolderUuid() {
      return this.previousDocument ? this.previousDocument.attributes.folder_uuid : ''
    },
    show() {
      return this.$store.state.document.replaceDocumentModal.open
    },
  },
  methods: {
    replace() {
      this.$api
        .active()
        .put(`documents/${this.previousDocument.uuid}/replace`, {
          newDocumentUuid: this.uploadedFile.uuid,
        })
        .then(() => {
          this.$store.dispatch(
            'documentGetFolderDetails',
            this.previousDocumentFolderUuid
          )

          this.$store.commit('baseAddNotification', {
            type: 'success',
            title: 'Success',
            text: 'Document replaced!',
          })

          this.close()
        })
    },
    uploadHasErrored(file, response) {
      let errorMessage = response.message

      if (response.errors.file) {
        errorMessage = response.errors.file[0]
      }

      file.previewElement.querySelectorAll('.dz-error-message')[0].innerHTML = errorMessage
    },
    fileHasBeenUploaded(file, uuid) {
      file.uuid = uuid
      this.uploadedFile = file
    },
    close() {
      this.$store.commit('documentCloseReplaceDocumentModal')
    },
  },
}
</script>
